import React, { useRef, useEffect } from "react";
import "./quemsomos.css";

function QuemSomos() {
  const trackRef = useRef(null);
  const isDragging = useRef(false);
  const pauseAutoplay = useRef(false);
  const startX = useRef(0);
  const scrollLeft = useRef(0);

  /* AUTOPLAY SUAVE */
  useEffect(() => {
    const track = trackRef.current;

    const autoplay = () => {
      if (!isDragging.current && !pauseAutoplay.current) {
        track.scrollLeft += 0.4;
        if (track.scrollLeft >= track.scrollWidth / 2) {
          track.scrollLeft = 0;
        }
      }
      requestAnimationFrame(autoplay);
    };

    requestAnimationFrame(autoplay);
  }, []);

  /* DRAG */
  const handleMouseDown = (e) => {
    isDragging.current = true;
    pauseAutoplay.current = true;
    startX.current = e.pageX;
    scrollLeft.current = trackRef.current.scrollLeft;
  };

  const handleMouseUp = () => {
    isDragging.current = false;
    setTimeout(() => {
      pauseAutoplay.current = false;
    }, 3000);
  };

  const handleMouseMove = (e) => {
    if (!isDragging.current) return;
    const walk = (e.pageX - startX.current) * 1.6;
    trackRef.current.scrollLeft = scrollLeft.current - walk;
  };

  /* SETAS */
  const scrollByCard = (direction) => {
    pauseAutoplay.current = true;
    const cardWidth = 360 + 24;

    trackRef.current.scrollBy({
      left: direction === "right" ? cardWidth : -cardWidth,
      behavior: "smooth",
    });

    setTimeout(() => {
      pauseAutoplay.current = false;
    }, 3000);
  };

  return (
    <section id="quem-somos" className="quem-somos-section">
      <div className="container">

        {/* TÍTULO */}
        <div className="titulo-bloco text-center">
          <h2>Quem Somos</h2>
          <span className="linha-destaque"></span>
        </div>

        {/* BLOCO TEXTO LARGO */}
        <div className="row">
          <div className="col-12 conteudo-texto text-center">

            <h3>Somos a TCC Engenharia</h3>
            <p className="texto-destaque">
              A <strong>TCC Engenharia</strong> é uma empresa especializada em
              orientação acadêmica e suporte técnico-científico voltados a
              estudantes e profissionais das áreas de
              <strong> Engenharia Civil</strong> e
              <strong> Engenharia de Produção</strong>.
            </p>

            <p>
              Nossa atuação concentra-se no acompanhamento metodológico e
              técnico de <strong>Trabalhos de Conclusão de Curso (TCC)</strong>,
              artigos científicos e estudos aplicados, sempre em conformidade
              com as normas da <strong>ABNT</strong>.
            </p>

          </div>
        </div>

        {/* BLOCO COM IMAGEM LATERAL */}
        <div className="row align-items-start mt-4">

          <div className="col-md-7 conteudo-texto text-center">

            <h3>Nossa Atuação</h3>
            <p>
              A <strong>TCC Engenharia</strong> dedica-se à orientação acadêmica e
              ao suporte técnico-científico em trabalhos de Engenharia Civil e de
              Produção.
            </p>

            <p>
              Nossa atuação prioriza <strong>rigor metodológico</strong>,
              <strong> consistência técnica</strong> e
              <strong> conformidade normativa</strong>.
            </p>

            <h3>Fundamentos</h3>
            <p>
              A <strong>TCC Engenharia</strong> fundamenta sua atuação no
              <strong> rigor técnico</strong>, na
              <strong> ética acadêmica</strong> e na
              <strong> clareza metodológica</strong>.
            </p>

          </div>

          <div className="col-md-5 imagem-area">
            <div className="imagem-wrapper">
              <img
                src="/Images/quem-somos.jpg"
                alt="Equipe técnica da TCC Engenharia"
              />
              <div className="credito-imagem text-center">
                TCC Engenharia — Orientação Acadêmica
              </div>
            </div>
          </div>

        </div>

        {/* CARROSSEL – VALORES / MISSÃO / VISÃO */}
        <div className="carousel-wrapper mt-5">

          <button
            className="carousel-arrow left"
            onClick={() => scrollByCard("left")}
          >
            ‹
          </button>

          <button
            className="carousel-arrow right"
            onClick={() => scrollByCard("right")}
          >
            ›
          </button>

          <div
            className="carousel-track"
            ref={trackRef}
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
            onMouseMove={handleMouseMove}
          >
            {/* VALORES */}
            <article className="quem-card">
              <h4>Valores</h4>
              <p>
                Atuamos com <strong>ética acadêmica</strong>,
                <strong> rigor metodológico</strong> e
                <strong> responsabilidade científica</strong>.
              </p>
              <p>
                Valorizamos a <strong>clareza conceitual</strong> e a
                <strong> consistência técnica</strong>.
              </p>
            </article>

            {/* MISSÃO */}
            <article className="quem-card">
              <h4>Missão</h4>
              <p className="texto-destaque">
                Oferecer orientação acadêmica e suporte técnico-científico,
                promovendo rigor metodológico, clareza conceitual e respeito à
                autoria intelectual.
              </p>
            </article>

            {/* VISÃO */}
            <article className="quem-card">
              <h4>Visão</h4>
              <p>
                Ser referência em orientação acadêmica nas áreas de Engenharia
                Civil e de Produção, reconhecida pela qualidade técnica, ética e
                contribuição científica.
              </p>
            </article>

          </div>
        </div>

      </div>
    </section>
  );
}

export default QuemSomos;
